/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, {useEffect, useState} from 'react'

import {motion, AnimatePresence, useAnimation} from 'framer-motion'
import classNames from 'classnames'

export const RealWorld = () => {
  const [[page, direction], setPage] = useState([0, 0])
  const controls = useAnimation()

  const variants = {
    enter: (direction: number) => {
      return {
        x: direction > 0 ? 100 : -100,
        opacity: 0,
      }
    },
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1,
    },
    exit: (direction: number) => {
      return {
        zIndex: 0,
        x: direction > 0 ? -100 : 100,
        opacity: 0,
      }
    },
  }

  useEffect(() => {
    const element = document.querySelector('.CustomAI__realWorld')
    const onScroll = () => {
      const elementTop = element.getBoundingClientRect().top
      const windowHeight = window.innerHeight

      if (elementTop < windowHeight * 0.75) {
        controls.start({opacity: 1, y: 0})
      } else {
        controls.start({opacity: 0, y: 50})
      }
    }

    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [controls])

  const data = [
    {
      title: 'Manufacturing',
      key: 'manufacturing',
      img: '',
      content: [
        {
          label: 'Supply Chain Management',
          des: 'เพิ่มประสิทธิภาพการจัดการสินค้าคงคลัง การทำนายความต้องการและการวางแผน Logistics',
        },
        {
          label: 'Predictive Maintenance',
          des: 'ระบบการบำรุงรักษาเชิงพยากรณ์เพื่อทำนายความต้องการในการบำรุง รักษา เครื่องจักรหรือระบุความเสียหายที่อาจเกิดขึ้นได้ล่วงหน้า',
        },
        {
          label: 'Safety Inspection',
          des: 'ระบบตรวจสอบความปลอดภัยอัตโนมัติ ให้เป็นไปตามมาตรฐานที่ กำหนดไว้',
        },
      ],
    },
    {
      title: 'Retail & Hospitality',
      key: 'retail',
      img: '',
      content: [
        {
          label: 'Customer Segmentation',
          des: 'แบ่งกลุ่มลูกค้าจากลักษณะที่คล้ายกันเพื่อการกำหนดเป้าหมายทางการตลาดให้ชัดเจนยิ่งขึ้น',
        },
        {
          label: 'Product Propensity',
          des: 'แนะนำสินค้าที่ใกล้เคียงกับความสนใจของลูกค้าเฉพาะกลุ่ม โดยวิเคราะห์จากฐานข้อมูลการซื้อของลูกค้า',
        },
        {
          label: 'Dynamic Pricing',
          des: 'วิเคราะห์แนวโน้มของตลาดและพฤติกรรมของลูกค้าเพื่อกำหนดกลยุทธ์ด้านราคาที่เหมาะสม',
        },
      ],
    },
    {
      title: 'Financial Services',
      key: 'financial',
      img: '',
      content: [
        {
          label: 'Credit Scoring and Underwriting',
          des: 'ประเมินความน่าเชื่อถือทางเครดิตโดยการวิเคราะห์ประวัติและข้อมูลเครดิตแบบอัตโนมัติ',
        },
        {
          label: 'Churn Prevention',
          des: 'ระบุลูกค้าที่มีความเสี่ยงในการเลิกใช้บริการเพื่อปรับกลยุทธ์ในการรักษาฐานลูกค้าได้อย่างทันท่วงที',
        },
        {
          label: 'Fraud Detection',
          des: 'ระบุข้อมูลที่ผิดปกติ หรือข้อมูลที่ไม่สอดคล้องกันเพื่อป้องกันการฉ้อโกง',
        },
      ],
    },
    {
      title: 'Agriculture',
      key: 'agriculture',
      img: '',
      content: [
        {
          label: 'Crop Monitoring and Yield Prediction',
          des: 'ตรวจสอบคุณภาพและทำนายผลผลิตของพืชผลโดยการวิเคราะห์จากข้อมูลต่างๆ และภาพถ่ายดาวเทียม',
        },
        {
          label: 'Pest and Disease Detection',
          des: 'วิเคราะห์ภาพพืชผลและข้อมูลเพื่อตรวจหาศัตรูพืชโรคและการเจริญเติบโตของวัชพืช',
        },
        {
          label: 'Precision Agriculture',
          des: 'ปรับแนวทางการทำฟาร์มให้เหมาะสมโดยการวิเคราะห์จากสภาพอากาศ ความชื้นในดินและข้อมูลผลผลิต',
        },
      ],
    },
    {
      title: 'Marketing & Media',
      key: 'marketing',
      img: '',
      content: [
        {
          label: 'Sentiment Analysis',
          des: 'วิเคราะห์ความคิดเห็น ความรู้สึกของลูกค้าเพื่อดำเนินการติดตามผล',
        },
        {
          label: 'Targeted Marketing',
          des: 'การตลาดแบบกำหนดเป้าหมาย สร้างข้อความทางการตลาดเฉพาะกลุ่มตามความสนใจที่แตกต่างกัน',
        },
        {
          label: 'Social Trending',
          des: 'วิเคราะห์เทรนด์และประเด็นที่ถูกการกล่าวถึงบนโลกออนไลน์',
        },
      ],
    },
    {
      title: 'Logistics',
      key: 'logistics',
      img: '',
      content: [
        {
          label: 'Route Optimization',
          des: 'เพิ่มประสิทธิภาพในการกำหนดเส้นทางและตารางการขนส่ง เพื่อลดต้นทุนและเพิ่มประสิทธิภาพให้ดีขึ้น',
        },
        {
          label: 'Demand Planning',
          des: 'คาดการณ์ความต้องการจากข้อมูลในอดีต แนวโน้มของตลาด และปัจจัยภายนอก เพื่อการจัดสรรทรัพยากรให้มีประสิทธิภาพ',
        },
        {
          label: 'Warehouse Management',
          des: 'ทำให้การดำเนินงานในคลังสินค้าเป็นแบบอัตโนมัติเพื่อเพิ่มประสิทธิภาพงาน เช่น การติดตามสินค้า การบรรจุ และการจัดเก็บ',
        },
      ],
    },
  ]
  const tabs = [
    {title: 'Manufacturing', index: 0},
    {title: 'Retail & Hospitality', index: 1},
    {title: 'Financial Services', index: 2},
    {title: 'Agriculture', index: 3},
    {title: 'Marketing & Media', index: 4},
    {title: 'Logistics', index: 5},
  ]

  return (
    <motion.div
      className='CustomAI__realWorld'
      initial={{opacity: 0, y: 10}}
      animate={controls}
      transition={{duration: 0.1}}
    >
      <div className='CustomAI__realWorld__container'>
        <h2>
          Real-World AI
          <span>in Action</span>
        </h2>
        {/* tab mobile */}
        <div className='CustomAI__realWorld__container__tab--mobile'>
          <Tabs
            tabs={tabs}
            currentIndex={page}
            onChangeIndex={(index) => {
              const isNext = page < index ? 1 : -1
              setPage([index, isNext])
            }}
          />
        </div>
        {/* tab desktop */}
        <div className='CustomAI__realWorld__container__tab--desktop'>
          <Tabs
            tabs={tabs}
            currentIndex={page}
            onChangeIndex={(index) => {
              const isNext = page < index ? 1 : -1
              setPage([index, isNext])
            }}
          />
        </div>
        <div className='CustomAI__realWorld__container__content'>
          {/* @ts-ignore */}
          <div className='desktop'>
            {/* @ts-ignore */}
            <AnimatePresence initial={false} custom={direction} exitBeforeEnter>
              <motion.div
                className='cards'
                key={data[page].key}
                variants={variants}
                custom={direction}
                initial='enter'
                animate='center'
                exit='exit'
                transition={{
                  opacity: {duration: 0.6},
                }}
              >
                <div className='card'>
                  <img
                    src={`/images/custom-ai/${data[page].key}-${tabs[1].index}.jpg`}
                  />

                  <div className='card__content__list__label'>
                    <h3>{data[page].content[0].label}</h3>
                  </div>
                  <div className='card__content__list__description'>
                    <p>{data[page].content[0].des}</p>
                  </div>
                </div>
                <div className='card'>
                  <img
                    src={`/images/custom-ai/${data[page].key}-${tabs[2].index}.jpg`}
                  />

                  <div className='card__content__list__label'>
                    <h3>{data[page].content[1].label}</h3>
                  </div>
                  <div className='card__content__list__description'>
                    <p>{data[page].content[1].des}</p>
                  </div>
                </div>
                <div className='card'>
                  <img
                    src={`/images/custom-ai/${data[page].key}-${tabs[3].index}.jpg`}
                  />
                  <div className='card__content__list__label'>
                    <h3>{data[page].content[2].label}</h3>
                  </div>
                  <div className='card__content__list__description'>
                    <p>{data[page].content[2].des}</p>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>
          <div className='mobile'>
            {/* @ts-ignore */}
            <AnimatePresence initial={false} custom={direction} exitBeforeEnter>
              <motion.div
                className='cards'
                key={data[page].key}
                variants={variants}
                custom={direction}
                initial='enter'
                animate='center'
                exit='exit'
                transition={{
                  opacity: {duration: 0.6},
                }}
              >
                <div className='card'>
                  <div className='card__img'>
                    <img
                      src={`/images/custom-ai/${data[page].key}-${tabs[1].index}.jpg`}
                    />
                  </div>

                  <div className='card__content__list__label'>
                    <h3>{data[page].content[0].label}</h3>
                  </div>
                  <div className='card__content__list__description'>
                    <p>{data[page].content[0].des}</p>
                  </div>
                </div>
                <div className='card'>
                  <img
                    src={`/images/custom-ai/${data[page].key}-${tabs[2].index}.jpg`}
                  />

                  <div className='card__content__list__label'>
                    <h3>{data[page].content[1].label}</h3>
                  </div>
                  <div className='card__content__list__description'>
                    <p>{data[page].content[1].des}</p>
                  </div>
                </div>
                <div className='card'>
                  <img
                    src={`/images/custom-ai/${data[page].key}-${tabs[3].index}.jpg`}
                  />
                  <div className='card__content__list__label'>
                    <h3>{data[page].content[2].label}</h3>
                  </div>
                  <div className='card__content__list__description'>
                    <p>{data[page].content[2].des}</p>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </motion.div>
  )
}

type TabsProps = {
  tabs: {title: string; index: number}[]
  currentIndex: number
  onChangeIndex: (page: number) => void
}
const Tabs = ({currentIndex, onChangeIndex, tabs}: TabsProps) => {
  return (
    <div className='CustomAI__realWorld__container__tabs'>
      {tabs.map((item) => {
        return (
          <motion.div
            className={classNames('item', {
              'item--active': currentIndex === item.index,
            })}
            onClick={() => onChangeIndex(item.index)}
            key={item.title}
          >
            <div className='item__content'>
              <p>{item.title}</p>
            </div>
          </motion.div>
        )
      })}
    </div>
  )
}
